<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div id="dados-formulario-tab" class="card">
        <div class="card-body">
          <div id="titulo">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <h4>Editar Veículo</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 pull-right">
                <input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoVeiculo" class="btn btn-warning" to="/veiculos">
                  <span class="glyphicon glyphicon-back"></span> Fechar
                </router-link>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div class="tabbable">
                <!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tab1" data-toggle="tab" class="nav-link active">Geral</a></li>
                </ul>

                <div class="tab-content">
                  <div class="tab-pane active" id="tab1">
                    <div class="dados_form">
                      <div class="col-sm-12 col-md-12">
                        <input type="hidden" v-model="model.id" />
                        <div class="row">
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Placa:</label><br>
                            <input class="pula form-control placa" v-model="model.placa" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-8 col-md-8">
                            <label class="control-label">Descrição:</label><br>
                            <input class="pula form-control" v-model="model.descricao"
                              required="required" />
                          </div>
                          
                          <div class="form-group col-sm-2 col-md-2">
                            <label>Data Cadastro:</label><br>
                            <template v-if="model.id === 0">
                              <input-data-picker class="pula data form-control" v-model="model.dataCadastroRastreamento" />
                            </template>
                            <template v-else>
                              <input-data-picker class="pula data form-control" v-model="model.dataCadastroRastreamento" readonly="readonly" />
                            </template>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-4 col-md-4">
                            <label class="control-label">Modelo:</label><br>
                            <input class="pula form-control" v-model="model.modelo" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Marca:</label><br>
                            <input class="pula form-control" v-model="model.marca" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-1 col-md-1">
                            <label class="control-label">Ano Fab.:</label><br>
                            <input class="pula form-control" v-model="model.anoFabricacao" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-1 col-md-1">
                            <label class="control-label">Ano Mod.:</label><br>
                            <input class="pula form-control" v-model="model.anoModelo" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Km Atual:</label><br>
                            <input class="pula form-control" v-model="model.kmAtual" />
                          </div>   
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-3 col-md-3">
                            <label>Alerta de Roubo Ativado:</label><br>
                            <select class="pula form-control" v-model="model.alertaRoubo">
                              <option value="false" label="Não" />
                              <option value="true" label="Sim" />
                            </select>
                          </div>
                        </div>


                        <div class="card">
                          <div class="card-header">
                            Rastreamento
                          </div>
                          <div class="card-body">

                              
                            <div class="row">
                              <div class="form-group col-sm-6 col-md-6">
                                <label class="control-label">Senha Identificação:</label><br>
                                <input class="pula form-control " v-model="model.senhaIdentificacao" />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="card">
                          <div class="card-header">
                            Análises
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="form-group col-sm-3 col-md-3">
                                <label class="control-label">Velocidade Máxima:</label><br>
                                <input class="pula form-control " v-model="model.velocidadeMaxima" />
                              </div>
                              <div class="form-group col-sm-3 col-md-3">
                                <label class="control-label">Tensao Bateria Minima:</label><br>
                                <input class="pula form-control " v-model="model.tensaoBateriaMinima" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      model: {
        id: '0',
        ativo: false,
        ativoRastreamento: false,
        ativoMonitoramento: false,
        placa: '',
        descricao: '',
        dataCadastroRastreamento: '',
        clienteId: '0',
        clienteNomeFantasia: '',
        modelo: '',
        marca: '',
        anoFabricacao: '',
        anoModelo: '',
        veiculoTipoId: '0',
        veiculoCombustivelId: '0',
        renavam: '',
        chassi: '',
        kmAtual: '0',
        numeroEquipamento: '',
        marcaEquipamento: '',
        modeloEquipamento: '',
        operadoraChipEquipamento: '',
        dddChipEquipamento: '',
        numeroChipEquipamento: '',
        dataInstalacao: '',
        ativoObd: '',
        numeroObd: '',
        marcaObd: '',
        modeloObd: '',
        operadoraChipObd: '',
        dddChipObd: '',
        numeroChipObd: '',
        dataInstalacaoObd: '',
        ativoTeclado: '',
        tipoUsoTeclado: '',
        clientePagaId: '',
        clientePagaNomeFantasia: '',
        clienteRedirecionamento1Id: '',
        clienteRedirecionamento1NomeFantasia: '',
        clienteRedirecionamento2Id: '',
        clienteRedirecionamento2NomeFantasia: '',
        clienteRedirecionamento3Id: '',
        clienteRedirecionamento3NomeFantasia: '',
        senhaIdentificacao: '',
        observacaoInstalacao: '',
        observacaoGerais: '',
        analisarIgnicao: true,
        analisarTransmissso: true,
        analisarDAC: true,
        analisarEvento: true,
        emOperacao: true,
        intervaloMovimento: '0',
        limiteGPS: '0',
        limiteTempo: '0',
        limiteTransmissoesDiarias: '0',
        velocidadeMaxima: '0',
        limiteExcessoVelocidade: '0',
        tensaoBateriaMinima: '0',
        jornadaTrabalho: true,
        jornadaTrabalhoIgnicao: true,
        jornadaTrabalhoVelocidade: '',
        jornadaTrabalhoParadoAposPosicoes: '',
        tipoNegociacao: '',
        vendedorRastreamento: '',
        tipoPagamentoRastreamento: '',
        mesVencimentoAnualRastreamento: '',
        tipoVencimentoRastreamento: 'C',
        diaVencimentoRastreamento: '1',
        sascarId: '0',
        valorRepasse: '0',
        valorMensalidadeRastreamento: '0',
        extra24Horas: '0',
        extraSeguro: '0',
        extraWeb: '0',
        valorTotalMensalidadeRastreamento: '0'
      },
      veiculosCombustiveis: [],
      veiculosTipos: [],
      vendedores: []
    }
  },
  created: function () {
    this.buscar()
    this.buscarVeiculosTipos()
    this.buscarVeiculosCombustivel()
    this.buscarVendedores()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        // self.model = response.data
        self.model.id = dados.id
        self.model.ativo = dados.ativo
        self.model.ativoRastreamento = dados.ativoRastreamento
        self.model.ativoMonitoramento = dados.ativoMonitoramento
        self.model.placa = dados.placa
        self.model.descricao = dados.descricao
        self.model.dataCadastroRastreamento = dados.dataCadastroRastreamento
        self.model.clienteId = dados.clienteId
        self.model.clienteNomeFantasia = dados.clienteNome
        self.model.modelo = dados.modelo
        self.model.marca = dados.marca
        self.model.anoFabricacao = dados.anoFabricacao
        self.model.anoModelo = dados.anoModelo
        self.model.veiculoTipoId = dados.veiculoTipoId
        self.model.veiculoCombustivelId = dados.veiculoCombustivelId
        self.model.renavam = dados.renavam
        self.model.chassi = dados.chassi
        self.model.kmAtual = dados.kmAtual
        self.model.numeroEquipamento = dados.numeroEquipamento
        self.model.marcaEquipamento = dados.marcaEquipamento
        self.model.modeloEquipamento = dados.modeloEquipamento
        self.model.operadoraChipEquipamento = dados.operadoraChipEquipamento
        self.model.dddChipEquipamento = dados.dddChipEquipamento
        self.model.numeroChipEquipamento = dados.numeroChipEquipamento
        self.model.dataInstalacao = dados.dataInstalacao
        self.model.ativoObd = dados.ativoObd
        self.model.numeroObd = dados.numeroObd
        self.model.marcaObd = dados.marcaObd
        self.model.modeloObd = dados.modeloObd
        self.model.operadoraChipObd = dados.operadoraChipObd
        self.model.dddChipObd = dados.dddChipObd
        self.model.numeroChipObd = dados.numeroChipObd
        self.model.dataInstalacaoObd = dados.dataInstalacaoObd
        self.model.ativoTeclado = dados.ativoTeclado
        self.model.tipoUsoTeclado = dados.tipoUsoTeclado
        self.model.clientePagaId = dados.clientePagaId
        self.model.clientePagaNomeFantasia = dados.clientePagaNome
        self.model.clienteRedirecionamento1Id = dados.clienteRedirecionamento1Id
        self.model.clienteRedirecionamento1NomeFantasia = dados.clienteRedirecionamento1Nome
        self.model.clienteRedirecionamento2Id = dados.clienteRedirecionamento2Id
        self.model.clienteRedirecionamento2NomeFantasia = dados.clienteRedirecionamento2Nome
        self.model.clienteRedirecionamento3Id = dados.clienteRedirecionamento3Id
        self.model.clienteRedirecionamento3NomeFantasia = dados.clienteRedirecionamento3Nome
        self.model.senhaIdentificacao = dados.senhaIdentificacao
        self.model.observacaoInstalacao = dados.observacaoInstalacao
        self.model.observacaoGerais = dados.observacaoGerais
        self.model.analisarIgnicao = dados.analisarIgnicao
        self.model.analisarTransmissso = dados.analisarTransmissso
        self.model.analisarDAC = dados.analisarDAC
        self.model.analisarEvento = dados.analisarEvento
        self.model.emOperacao = dados.emOperacao
        self.model.intervaloMovimento = dados.intervaloMovimento
        self.model.limiteGPS = dados.limiteGPS
        self.model.limiteTempo = dados.limiteTempo
        self.model.limiteTransmissoesDiarias = dados.limiteTransmissoesDiarias
        self.model.velocidadeMaxima = dados.velocidadeMaxima
        self.model.limiteExcessoVelocidade = dados.limiteExcessoVelocidade
        self.model.tensaoBateriaMinima = dados.tensaoBateriaMinima
        self.model.jornadaTrabalho = dados.jornadaTrabalho
        self.model.jornadaTrabalhoIgnicao = dados.jornadaTrabalhoIgnicao
        self.model.jornadaTrabalhoVelocidade = dados.jornadaTrabalhoVelocidade
        self.model.jornadaTrabalhoParadoAposPosicoes = dados.jornadaTrabalhoParadoAposPosicoes
        self.model.tipoNegociacao = dados.tipoNegociacao
        self.model.vendedorRastreamento = dados.vendedorRastreamento
        self.model.tipoPagamentoRastreamento = dados.tipoPagamentoRastreamento
        self.model.mesVencimentoAnualRastreamento = dados.mesVencimentoAnualRastreamento
        self.model.tipoVencimentoRastreamento = dados.tipoVencimentoRastreamento
        self.model.diaVencimentoRastreamento = dados.diaVencimentoRastreamento
        self.model.sascarId = dados.sascarId
        self.model.valorRepasse = dados.valorRepasse
        self.model.valorMensalidadeRastreamento = dados.valorMensalidadeRastreamento
        self.model.extra24Horas = dados.extra24Horas
        self.model.extraSeguro = dados.extraSeguro
        self.model.extraWeb = dados.extraWeb
        self.model.valorTotalMensalidadeRastreamento = dados.valorTotalMensalidadeRastreamento
      })
    },
    buscarVeiculosCombustivel: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVeiculosCombustiveisAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.veiculosCombustiveis = dados
      })
    },
    buscarVeiculosTipos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVeiculosTiposAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.veiculosTipos = dados
      })
    },
    buscarVendedores: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVendedoresAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.vendedores = dados
      })
    },
    setarCliente: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarCliente: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClientePaga: function (cliente) {
      this.model.clientePagaId = cliente.id
      this.model.clientePagaNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clientePagaNome').val(cliente.nomeFantasia)
    },
    verificarClientePaga: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clientePagaId = 0
        this.model.clientePagaNome = ''
        $(this.$el).find('#clientePagaId').val(0)
        $(this.$el).find('#clientePagaNome').val('')
      }
      if ($(this.$el).find('#clientePagaNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clientePagaId').val(0)
        $(this.$el).find('#clientePagaNome').val('')
      }
    },
    setarClienteRedirecionamento1: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento1: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClienteRedirecionamento2: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento2: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClienteRedirecionamento3: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento3: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/veiculos/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo gravado com sucesso.', 'Atenção')
              self.$router.replace('/veiculos')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/areas/AreasEditar.vue